import React, { useMemo } from 'react';
import { View } from 'react-native';
import { ArenaStatsBanner } from '../ArenaStatsBanner/ArenaStatsBanner';
import { ChallengeCardSkeleton } from '../ChallengeCardSkeleton';
import { Skeleton } from '../../ui/Skeleton';
import { FILTER_OPTIONS } from '../../../src/challenges/types/challenges.types';
import { getChallengesPageStyles } from '../../../src/challenges/styles/challenges.styles';
import { useTheme } from '../../../src/theme/useTheme';

export const ArenaLoadingSkeleton: React.FC = () => {
  const theme = useTheme();
  const styles = useMemo(() => getChallengesPageStyles(theme), [theme]);

  return (
    <>
      <ArenaStatsBanner stats={null} isLoading />
      <View style={styles.filterBarSkeletonRow}>
        {FILTER_OPTIONS.map((option) => (
          <View key={`arena-filter-skeleton-${option.key}`} style={styles.filterBarSkeletonPill}>
            <Skeleton width="100%" height={28} borderRadius={18} />
          </View>
        ))}
      </View>
      <View style={styles.sectionContainer}>
        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Skeleton width={100} height={14} borderRadius={6} />
          </View>
          <ChallengeCardSkeleton />
          <ChallengeCardSkeleton />
          <ChallengeCardSkeleton />
        </View>
      </View>
      <View style={styles.sectionContainer}>
        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <Skeleton width={80} height={14} borderRadius={6} />
          </View>
          <ChallengeCardSkeleton />
          <ChallengeCardSkeleton />
        </View>
      </View>
    </>
  );
};
